module.exports = __webpack_public_path__ + "img/ac4BHDMI.62977665.jpeg";